export const HOME_PAGE_SEARCH_INPUT_ID = 'my-search';

export const HEADER_ID = 'website-header';

export const HEADER_SEARCH_INPUT_ID = 'my-search-header';

export const JOB_TITLE_PAGE_SEARCH_INPUT_ID = 'job-title-search';

export const JOB_TITLE_PAGE_CITY_SEARCH_ID = 'job-title-city-search';

export const JOB_TITLE_PAGE_SUBSCRIBE_CITY_SEARCH_ID =
  'job-title-subscribe-city-search';

export const CULTURAL_QUIZ_ID = 'quiz';

export const RESUME_CONSULT_SERVICE_ID = 'resume_consult-srvice';

export const RESUME_IFRAME_ID = 'resume-iframe';

export const JOB_TITLE_PAGE_SUBSCRIBE1 = 'job_title_page-subscribe1';

export const JOB_TITLE_PAGE_SUBSCRIBE2 = 'job_title_page-subscribe2';

export const HOME_PAGE_RESUME_CONSULT = 'home_page-resume-consult';

export const RESUME_DASHBOARD_NAV_ID = 'resume-dashboard-nav';

export const NOT_FOUND_PAGE_ID = 'not-found';

export const LOGIN_CODE_CAPTCHA_ID = 'login-code-captcha';

export const LOGIN_CODE_CAPTCHA_CLICK_ID = 'login-code-captcha-click';

export const HOME_PAGE_RESUME_EVALUATION_ID = 'home_page-resume-evaluation';

export const EVALUATION_PAYMENT_ID = 'evaluation_payment';

export const EVALUATION_INTRO_ID = 'evaluation_intro';

export const CITY_PAGE_SALARY_INSIGHT_ID = 'city_page-salary-insight';
export const CITY_PAGE_RECRUITMENT_TREND_ID = 'city_page-recruitment-trend';

export const RESUME_EVALUATION_FULL_PAGE_GENERAL_COMMENT_ID =
  'resume-evaluation-full_page-general-comment';
export const RESUME_EVALUATION_FULL_PAGE_SPECIFIC_MODULES_ID =
  'resume-evaluation-full_page-specific-modules';
export const RESUME_EVALUATION_FULL_PAGE_PROFESSIONAL_IMAGE_ID =
  'resume-evaluation-full_page-professional-image';

export const RESUME_EVALUATION_GENERAL_COMMENT_ID =
  'resume-evaluation-general-comment';
export const RESUME_EVALUATION_BASE_ABOUT_ME_ID =
  'resume-evaluation-base-about-me';
export const RESUME_EVALUATION_WORK_EXPERIENCE_ID =
  'resume-evaluation-work-experience';
export const RESUME_EVALUATION_PROJECT_EXPERIENCE_ID =
  'resume-evaluation-project-experience';
export const RESUME_EVALUATION_EDUCATION_EXPERIENCE_ID =
  'resume-evaluation-education-experience';
export const RESUME_EVALUATION_PROFESSIONAL_IMAGE_ID =
  'resume-evaluation-professional-image';

export const RESUME_TEMPLATE_BASE_ABOUT_ME_ID = 'resume-template-base-about-me';
export const RESUME_TEMPLATE_WORK_EXPERIENCE_ID =
  'resume-template-work-experience';
export const RESUME_TEMPLATE_PROJECT_EXPERIENCE_ID =
  'resume-template-project-experience';
export const RESUME_TEMPLATE_EDUCATION_EXPERIENCE_ID =
  'resume-template-education-experience';
